angular.module('unica_approvation_list.approvation_list_services')

.factory('ApprovationListDeleteService', function ($http, getBaseApiURL) {


	var approvationListDeleteService = {};


	approvationListDeleteService.delete = function ( approvationListId )
	{
		return $http({
			method: 'DELETE',
			url: getBaseApiURL + '/approvation-list/delete/' + approvationListId,
			data: { }
		}).then(function(result) {

			if ( result ) {
				return true;
			}

		});
	};


	return approvationListDeleteService;
});